import React, { useState, useEffect, forwardRef } from 'react';
import Grid from '@material-ui/core/Grid'
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import { ThemeProvider } from "@material-ui/core"
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import axios from 'axios'
import Alert from '@material-ui/lab/Alert';
import { Link } from 'react-router-dom';
import FormDatePicker from '../../components/DatePicker';
import FormControl from '@material-ui/core/FormControl';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useSelector, useDispatch } from "react-redux";

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const api = axios.create({
    baseURL: 'SlipSummary'
})
//const apimst = axios.create({
//    baseURL: 'MasterDetails'
//})

function SlipSummary() {
    const [data, setData] = useState([]);
    //for progress
    const [openLoader, setopenLoader] = useState(false);
                   
     //table data
     var columns = [
        { title: 'id', field: 'id', hidden: true },
        { title: "Entry No", field: "viewEntryNumber" },
        { title: 'Shop', field: 'mrpcontroller' },
        { title: 'Shift', field: 'shiftName' },
        { title: 'Employee Name', field: 'worker' },
        { title: 'Entry Date', field: 'entryDate', type: 'date', dateSetting: { locale: "en-GB" }, },
        { title: 'Status', field: 'statusName' },
         { title: 'Created By', field: 'created' },
         { title: 'Modified By', field: 'modified' },
    ]
    
    ////Sub-Data
    //var subCols = [
    //    {
    //        title: 'Input Mins',
    //        field: 'inputTime'
    //    },
    //    {
    //        title: 'Output Mins',
    //        field: 'enteredTime'
    //    },
    //    {
    //        title: 'Efficiency',
    //        field: 'efficiency'
    //    },
    //    {
    //        title: 'Idle Time',
    //        field: 'idleTime'
    //    },
    //];

    //for error handling
    const [iserror] = useState(false)
    const [errorMessages] = useState([])
    const [fromdate, setFromdate] = useState(null);
    const [todate, setTodate] = useState(null);

    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);
    //for alert showing
    const [open, setopen] = useState('');
    const [openAlert, setopenAlert] = useState('');
    const [openClassName, setopenClassName] = useState('');
    const [openType, setopenType] = useState('');

    //const [alertsuccess, setalertsuccess] = useState("Success");
    const [alerterror] = useState("Alert");
    //const [alertsuccessclass, setalertsuccessclass] = useState("bg-light-green clr-white");
    const [alerterrorclass] = useState("bg-red clr-white");

    function showMsg(popen, popenAlert, popenClassName, popenType) {
        setopen(popen);
        setopenAlert(popenAlert);
        setopenClassName(popenClassName);
        setopenType(popenType);
    }

    function handleClose() {
        setopen(false);
    }
    
    function dateChangeEvent(dateValue, label) {
        if (label === "From Date") {
            if (todate !== null) {
                if ((Date.parse(dateValue) > Date.parse(todate))) {
                    showMsg(true, "From date should be less than To date", alerterrorclass, alerterror);
                    setFromdate(null);
                }
                else {
                    setFromdate(dateValue);
                    localStorage.setItem("FromDate", dateValue);
                }
            }
            else {
                setFromdate(dateValue);
                localStorage.setItem("FromDate", dateValue);
            }
        }
        else if (label === "To Date") {
            if ((Date.parse(fromdate) > Date.parse(dateValue))) {
                showMsg(true, "From date should be greater than To date", alerterrorclass, alerterror);
                setTodate(null);
            }
            else {
                setTodate(dateValue);
                localStorage.setItem("ToDate", dateValue);
            }
        }
    }

    function GetFilterSlipSummary() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        setopenLoader(true);
        //console.log(localStorage.getItem("FromDate"));
        //console.log(localStorage.getItem("ToDate"));
        let slipDet = {
            FromDate: fromdate,
            ToDate: todate
        }
        api.post("/getSlipSummaryList/", slipDet,{
            headers: headers
        })
            .then(res => {
                setData(res.data);
                //console.log(res.data);
                setopenLoader(false);
            })
            .catch(error => {
                setopenLoader(false);
                console.log("Error in hitting api : GetFilterSlipSummary")
            })
    }

    const SearchTable = (event) => {
        GetFilterSlipSummary();
    };

    useEffect(() => {
        //alert('alert');
        let from = localStorage.getItem("FromDate");
        let to = localStorage.getItem("ToDate");
      //  console.log(from);
       // console.log(to);
        if (from === null || from === undefined || from === "" || from === "null") {
            setFromdate(null);
        }
        else {
            setFromdate(new Date(from));
        }
        if (to === null || to === undefined || to === "" || to === "null") {
            setTodate(null);
        }
        else {
            setTodate(new Date(to));
        }
       GetFilterSlipSummary();
    }, [])    

    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data">
                <Box paddingTop={{ xs: '5rem', sm: '2rem' }} className="">
                    <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1">Dashboard</h3>
                </Box>
                <Grid container spacing={1} className="d-flex jc-center mb-2 bdr-radius">
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <FormControl className="width-100 mt-05">
                            <FormDatePicker
                                id="FromDate"
                                placeholder="From Date"
                                label="From Date"
                                value={fromdate}
                                onChange={dateChangeEvent}
                                disablefuturedate={true}
                                required={true}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={3} className="d-flex Width-100">
                        <FormControl className="width-100 mt-05">
                            <FormDatePicker
                                id="ToDate"
                                placeholder="To Date"
                                label="To Date"
                                value={todate}
                                onChange={dateChangeEvent}
                                disablefuturedate={true}
                                required={true}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={1} className="d-flex mt-05">
                        <Tooltip title="Filter Result" placement="right" arrow onClick={SearchTable} >
                            <Button className="download-icon" startIcon={<FilterList />}>
                            </Button>
                        </Tooltip>
                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex Width-100">
                    </Grid>
                    <Grid item xs={12} sm={2} className="d-flex Width-100">
                        <a href="../SlipCreation">
                            <Button item className="ns-btn-primary mt-1">
                                <span>Add</span>
                            </Button>
                        </a>
                    </Grid>
                    <Grid item xs={12} sm={11} className="userManagement mt-1 mb-1">
                        <div>
                            {iserror &&
                                <Alert severity="error">
                                    {errorMessages.map((msg, i) => {
                                        return <div key={i}>{msg}</div>
                                    })}
                                </Alert>
                            }
                        </div>

                        <MaterialTable
                            title="Slip Summary"
                            columns={columns}
                            data={data}
                            icons={tableIcons}                            
                            detailPanel={rowData => {
                                return (
                                    <div className="p-1 ml-1 detail-dashboard">
                                        <div>Input Minutes  : {rowData.inputTime}</div>
                                        <div>Output Minutes : {rowData.enteredTime}</div>
                                        <div>Efficiency     : {rowData.efficiency}</div>
                                        <div>Idle Time      : {rowData.idleTime}</div>
                                    </div>
                                );
                            }}
                            options={{
                                pageSizeOptions: [30, 40, 50],    // rows selection options
                                pageSize: 30,
                                maxBodyHeight: 600,
                            }}
                            actions={[
                                rowData => ({
                                    icon: () => <Link to={"/SlipCreation?ID=" + `${window.btoa(rowData.id)}`}><EditOutlinedIcon fontSize="small" /></Link>,
                                      tooltip: 'Edit',
                                    onClick: (rowData),
                                })
                            ]}
                        />
                    </Grid>
                </Grid>
                <Dialog
                    open={openLoader}
                    //onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess"
                    PaperProps={{
                        style: {
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            borderColor: "transparent"
                        },
                    }}>
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess">
                    <DialogTitle className={openClassName} style={{ cursor: 'move' }} id="draggable-dialog-title">
                        {openType}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText className="clr-black">
                            {openAlert}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" autoFocus onClick={handleClose} className="ns-btn-secondary-light">
                            <span className="f-16 fw-bold">OK</span>
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </ThemeProvider>
    );
}

export default SlipSummary;